import React, { useState, useEffect } from 'react';
import dislike_icon from '../../Assets/Icons/dislike.svg';
import like_icon from '../../Assets/Icons/like.svg';
import send_icon from '../../Assets/Icons/icon-send.svg';
import { sendShortFeedback, addShortFeedbackMessage, checkUserFeedbackExists } from '../../lib/firebase/firestore';
import '../../UI/Common/FeedbackCard.css';
import DefaultButton from './Buttons/DefaultButton';

interface Props {
  userId: any;
  room: any;
}

export const FeedbackCard: React.FC<Props> = ({ userId, room }) => {
  const [step, setStep] = useState<'voting' | 'comment' | 'thanks' | 'hidden'>('voting');
  const [comment, setComment] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [hasAlreadySent, setHasAlreadySent] = useState(true);

  // Lógica de 30 segundos para aparecer
  useEffect(() => {
    const verifyAndStartTimer = async () => {
      const exists = await checkUserFeedbackExists(userId);
      setHasAlreadySent(exists);

      if (!exists) {
        const timer = setTimeout(() => {
          setIsVisible(true);
        }, 20000);
        return () => clearTimeout(timer);
      }
    };

    if (userId) verifyAndStartTimer();
  }, [userId]);

  // Lógica para o "Obrigado" sumir após 3 segundos
  useEffect(() => {
    if (step === 'thanks') {
      const timer = setTimeout(() => {
        setStep('hidden');
      }, 3000); // 3 segundos
      return () => clearTimeout(timer);
    }
  }, [step]);

  const handleVote = async (type: 'like' | 'dislike') => {
    try {
      await sendShortFeedback(userId, type, room);
      if (type === 'dislike') {
        setStep('comment');
      } else {
        setStep('thanks');
      }
    } catch (e) {
      console.error("Erro ao votar:", e);
    }
  };

  const handleSendComment = async () => {
    try {
      await addShortFeedbackMessage(userId, comment);
      setStep('thanks');
    } catch (e) {
      console.error("Erro ao enviar mensagem:", e);
    }
  };

  if (hasAlreadySent || !isVisible || step === 'hidden') return null;

  if (step === 'thanks') {
    return (
      <div className="feedback-container thanks">
        <span className="thanks-text">Obrigado ;)</span>
      </div>
    );
  }

  return (
    <div className="feedback-container">
      {step === 'voting' ? (
        <>
          <span className="feedback-title">Está gostando do Blinker?</span>
          <div className="feedback-buttons">
            <button className="feedback-btn" onClick={() => handleVote('dislike')}>
              <img src={dislike_icon} alt="Dislike" />
            </button>
            <button className="feedback-btn" onClick={() => handleVote('like')}>
              <img src={like_icon} alt="Like" />
            </button>
          </div>
        </>
      ) : (
        <div className="comment-section-modal">
            <div className='comment-header'>
                <p className="comment-label-title">Deixe seu feedback</p>
                <button className='close-comment' onClick={() => setStep('hidden')}>X</button>
            </div>
          
          <textarea 
            className="comment-input-large"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Escreva aqui o que poderíamos melhorar..."
          />
          
          <DefaultButton
            type="button" 
            text="Enviar" 
            iconRight={send_icon} 
            onClick={handleSendComment} 
            disabled={comment.length < 3} 
          />
        </div>
      )}
    </div>
  );
};